export const getRedirectUrlWithTopLevelCookieConsent = (currentUrl: string): string | null => {
    const url = new URL(currentUrl);

    if (url.searchParams.has("cookieConsent")) {
        return null;
    }

    const next = url.searchParams.get("next");

    if (!next) {
        return null;
    }

    const nestedUrl = new URL(next, url.origin);
    const cookieConsent = nestedUrl.searchParams.get("cookieConsent");

    if (!cookieConsent) {
        return null;
    }

    url.searchParams.set("cookieConsent", cookieConsent);

    return url.toString();
};
export const getRedirectUrlWithTopLevelCookieConsent = (currentUrl: string): string | null => {
    const url = new URL(currentUrl);

    if (url.searchParams.has("cookieConsent")) {
        return null;
    }

    const next = url.searchParams.get("next");

    if (!next) {
        return null;
    }

    const nestedUrl = new URL(next, url.origin);
    const cookieConsent = nestedUrl.searchParams.get("cookieConsent");

    if (!cookieConsent) {
        return null;
    }

    url.searchParams.set("cookieConsent", cookieConsent);

    return url.toString();
};
